import { Component }       from '@angular/core';
import { ActivatedRoute }  from '@angular/router';
import { Router }  from '@angular/router';
import { Location }        from '@angular/common';

import { PatientService } from '../../services/patients/patient.service';
import { DateService } from '../../services/date.service'

import { UserDetailComponent } from '../../users/detail/user-detail.component';

import { AppConfig } from '../../app.config';
import * as _ from 'lodash';
import { Auth } from '../../services/auth.service';

var Moment = require('moment');


@Component({
  moduleId: module.id,
  selector: 'my-patient-detail',
  templateUrl: 'patient-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class PatientDetailComponent extends UserDetailComponent {
  date:Date; //date from user
  dateForShow:string
  newDate:Date;
  newEmail:string
  newSecondaryEmail: string;
  newAuth0Id: string
  newValidator: string
  newPsId: string
  newPhone: string
  newMobilePhone: string
  newNotes: string
  dayAlert:boolean=false;
  badDateAlert:boolean=false;
  info:any;
  infoShow:string;
  createdAt:string;
  family:any[]=[]
  firstDataKeys:any[]=[]
  dynamicAttributesKeys:any[]=[]
  newSubscriberId
  isOnCovidMonitoringWorkflow: boolean = false;
  covidMonitoringStatus: string;
  covidMonitoringStatusDate: string;
  covidMonitoringStatusDateTitle: string;
  onMonitoring: boolean = false;
  medicalHistoryEmails: string;
  needsAutomaticUnban: boolean = true;
  newExternalId: string;
  newNeedsMonitoring: boolean = false;
  hasWritePatientPermission: boolean = false;
  hasClinicalHistoryPermission: boolean = false;
  hasReportsPermission: boolean = false;
  callPriority: number;

  priorityOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  constructor(
    protected patientService: PatientService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    protected config: AppConfig,
    protected dateService: DateService,
    protected auth: Auth
  ) { super(patientService, route, location);
    }

  protected getDefaultUserImageUrl(): string {

    return 'https://s3-eu-west-1.amazonaws.com/emoov-divi/sprites/default-avatar.png';
  };

  putDate(){
    this.date = new Date(this.updatedUser.birthDate * 1000);
    var month: number;
    month = this.date.getMonth()+1
    this.date = new Date(0); // The 0 there is the key, which sets the date to the epoch
    this.date.setUTCSeconds(this.updatedUser.birthDate);
    this.dateForShow = this.dateToString(this.date)
    this.createdAt = this.user.createdAt.slice(0,10); //ME QUEDO SOLO CON LA FECHA
    this.createdAt = this.createdAt.slice(8,10) + '-' + this.createdAt.slice(5,7) + '-' + this.createdAt.slice(0,4);
  }

  fillObject(){

    this.hasWritePatientPermission = this.auth.hasWritePatientPermission();
    this.hasClinicalHistoryPermission = this.auth.hasClinicalHistoryPermission();
    this.hasReportsPermission = this.auth.hasReportsPermission()
    if(!this.hasWritePatientPermission){
      $(document).ready (() => {
        var inputs = document.getElementsByTagName('input');
        var selects = document.getElementsByTagName('select');
        var textareas = document.getElementsByTagName('textarea')
        Array.from(inputs).forEach((input) => {if(input.getAttribute("id") != "medicalHistoryEmails") input.setAttribute("disabled","")});
        Array.from(selects).forEach((select) => select.setAttribute("disabled",""));
        Array.from(textareas).forEach((textarea) => textarea.setAttribute("disabled",""));
      })
    }

    this.isOnCovidMonitoringWorkflow = this.updatedUser &&
      (this.updatedUser.needsValidation||
        this.updatedUser.needsMonitoring ||
        this.updatedUser.failedValidation ||
        this.updatedUser.onMonitoring ||
        this.updatedUser.wasDischarged ||
        this.updatedUser.needsAdministrativeDischarge);

    if(this.updatedUser.needsValidation) {
      this.covidMonitoringStatus = "Needs validation";
      this.covidMonitoringStatusDateTitle = "Created at";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.createdAt);
    }
    else if(this.updatedUser.failedValidation) {
      this.covidMonitoringStatus = "Invalidated";
      this.covidMonitoringStatusDateTitle = "Invalidated date";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.invalidatedDate);
    }
    else if(this.updatedUser.needsMonitoring) {
      this.covidMonitoringStatus = "Needs monitoring";
      this.covidMonitoringStatusDateTitle = "Validation date";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.validationDate);
    }
    else if(this.updatedUser.onMonitoring) {
      this.covidMonitoringStatus = "On monitoring";
      this.covidMonitoringStatusDateTitle = "Validation date";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.validationDate);
    }
    else if((this.updatedUser.wasDischarged && !this.updatedUser.provider.needsAdministrativeDischarge) ||
      (this.updatedUser.wasDischarged && this.updatedUser.needsAdministrativeDischarge)) {
      this.covidMonitoringStatus = this.updatedUser.provider.needsAdministrativeDischarge ? "Needs administrative discharge" : "Discharged";
      this.covidMonitoringStatusDateTitle = "Discharge date";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.dischargeDate);
    }
    else if(this.updatedUser.wasDischarged && !this.updatedUser.needsAdministrativeDischarge && this.updatedUser.provider.needsAdministrativeDischarge) {
      this.covidMonitoringStatus = "Discharged";
      this.covidMonitoringStatusDateTitle = "Administrative discharge date";
      this.covidMonitoringStatusDate = this.dateService.convertToLocalDateString(this.updatedUser.administrativeDischargeDate);
    }
    else {
      this.covidMonitoringStatus = "-";
      this.covidMonitoringStatusDateTitle = "-";
      this.covidMonitoringStatusDate = null;
    }

    if(this.updatedUser.email != null && this.updatedUser.email != undefined)
      this.newEmail = this.updatedUser.email;

    if(this.updatedUser.secondaryEmail != null && this.updatedUser.secondaryEmail != undefined)
      this.newSecondaryEmail = this.updatedUser.secondaryEmail;

    if(this.updatedUser.notes != null && this.updatedUser.notes != undefined)
      this.newNotes = this.updatedUser.notes;

    if(this.updatedUser.auth0_user != null && this.updatedUser.auth0_user != undefined)
      this.newAuth0Id = this.updatedUser.auth0_user;

    if(this.updatedUser.validator != null && this.updatedUser.validator != undefined)
      this.newValidator = this.updatedUser.validator;

    if(this.updatedUser.psId != null && this.updatedUser.psId != undefined)
      this.newPsId = this.updatedUser.psId;

    if(this.updatedUser.mobilePhone != null && this.updatedUser.mobilePhone != undefined)
      this.newMobilePhone = this.updatedUser.mobilePhone;

    if(this.updatedUser.phone != null && this.updatedUser.phone != undefined)
      this.newPhone = this.updatedUser.phone;

    if(this.updatedUser.onMonitoring) {
      this.onMonitoring = this.updatedUser.onMonitoring;
    }

    if(this.updatedUser.callPriority != null && this.updatedUser.callPriority != undefined) {
      this.callPriority = this.updatedUser.callPriority;
    }

    if(this.updatedUser.externalId != null && this.updatedUser.externalId != undefined)
      this.newExternalId = this.updatedUser.externalId;

    if(this.updatedUser.needsMonitoring != null && this.updatedUser.needsMonitoring != undefined)
      this.newNeedsMonitoring = this.updatedUser.needsMonitoring;

    this.updatedUser.active =  this.updatedUser.active==undefined  || this.updatedUser.active
    this.updatedUser.billable =  this.updatedUser.billable==undefined  || this.updatedUser.billable
    if (this.updatedUser.firstData){
      this.firstDataKeys = Object.keys(this.updatedUser.firstData)
      if(this.updatedUser.firstData["birthDate"]){
        var date = new Date(0); // The 0 there is the key, which sets the date to the epoch
        date.setUTCSeconds(this.updatedUser["birthDate"]);
        this.updatedUser.firstData["birthDate"] = this.dateToString(date)
      }
    }

    if(this.updatedUser.subscriberId) this.newSubscriberId = this.updatedUser.subscriberId

    if(this.updatedUser.provider.dynamicAttributes)
    {
      var dynamicAttributes = this.updatedUser.provider.dynamicAttributes
      dynamicAttributes.forEach(attr => {
        this.dynamicAttributesKeys.push(attr.name);
      });
    }

  }
  saveAlerts(){
   /* if (this.newDate == undefined) {
      this.dayAlert=true;
      return;
    }
    this.dayAlert=false;
    this.saveAlert=true;*/
  }
  saveDate(){

    if(this.newEmail != undefined && this.newEmail != this.updatedUser.email)
    {
      this.updatedUser.email = this.newEmail
    }

    if(this.newSecondaryEmail != undefined && this.newSecondaryEmail != this.updatedUser.secondaryEmail)
    {
      this.updatedUser.secondaryEmail = this.newSecondaryEmail
    }

    if(this.newNotes != undefined && this.newNotes != this.updatedUser.notes)
    {
      this.updatedUser.notes = this.newNotes
    }

    if(this.newAuth0Id != undefined && this.newAuth0Id != this.updatedUser.auth0_user)
    {
      this.updatedUser.auth0_user = this.newAuth0Id
    }

    if(this.newValidator != undefined && this.newValidator != this.updatedUser.validator)
    {
      this.updatedUser.validator = this.newValidator
    }

    if(this.newPsId != undefined && this.newPsId != this.updatedUser.psId)
    {
      this.updatedUser.psId = this.newPsId
    }

    if(this.newPhone != undefined && this.newPhone != this.updatedUser.phone)
    {
      this.updatedUser.phone = this.newPhone
    }

    if(this.newMobilePhone != undefined && this.newMobilePhone != this.updatedUser.mobilePhone)
    {
      this.updatedUser.mobilePhone = this.newMobilePhone
    }

    if(this.newExternalId != undefined && this.newExternalId != this.updatedUser.externalId)
    {
      this.updatedUser.externalId = this.newExternalId
    }

    if(this.newNeedsMonitoring != undefined && this.newNeedsMonitoring != this.updatedUser.needsMonitoring)
    {
      this.updatedUser.needsMonitoring = this.newNeedsMonitoring
    }

    if(this.callPriority != undefined && this.callPriority != this.updatedUser.callPriority)
    {
      this.updatedUser.callPriority = this.callPriority
    }

    if (this.newDate == undefined) {
      this.saving()
      return
    }
    this.dayAlert=false;

    //SPLIT DEL DATE
    let dateParts:number[] = []
    let fecha:string='';
    let i;
    for (i=0;i<10;i++){
      if (this.newDate[i]=='-') {
        dateParts.push(Number(fecha))
        fecha='';
      }
      else  fecha+=this.newDate[i]
    }
    dateParts.push(Number(fecha))


    if(this.checkDate(dateParts) == false) {
      this.badDateAlert=true;
      return
    }
    this.badDateAlert=false;


    var date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

    var unixtime = Date.parse(date.toString())/1000;
    this.updatedUser.birthDate=unixtime;

    this.saving()

  }

  checkDate(dateParts: any):boolean{
    var currentTime = new Date()
    var month = currentTime.getMonth() + 1
    var day = currentTime.getDate()
    var year = currentTime.getFullYear()

    let myYear =Number(dateParts[0]);
    let myMonth =Number(dateParts[1])
    let myDay =Number(dateParts[2])

    if (myYear > year ) return false;
    if ((myYear==year )&& (myMonth > month )) return false;
    if ((myYear==year )&& (myMonth == month ) && (myDay > day)) return false;


    return true;
  }


  showInfo(){
    this.router.navigate([ '/patient/' + this.user.id +'/auth' ]);
  }


  getInfo(){
    return;
  }

  getFamily(){
    this.patientService.getFamily(this.user.familyGroup)
      .then(users => {
        this.family = users.members
        this.changeCreatedAt(this.family)
      })

  }
  changeCreatedAt(users:any[]){
    for (let i=0;i<users.length;i++){
      users[i].createdAt=users[i].createdAt.slice(8,10)+'/'+users[i].createdAt.slice(5,7)+'/'+users[i].createdAt.slice(0,4) +' '+users[i].createdAt.slice(11,19)
    }
  }

  searchInAmplitude(){
      window.open('https://analytics.amplitude.com/org/28301/project/'+this.config.get('AMPLITUDE_PROJECT_ID')+'/search/'+this.user.id, '_blank');
  }

  dateToString(date){
   return Moment(date.toUTCString()).utcOffset('+0000').format("DD/MM/YYYY")
  }

  registerSubscriber(newSubscriberId){
    return this.patientService.registerSubscriber(this.updatedUser.documentNumber, this.updatedUser.provider.id, newSubscriberId)
  }

  stopMonitoring(){
    return this.patientService.stopMonitoring(this.updatedUser.id)
    .then(() => {
      alert("Monitoreo detenido satisfactoriamente!");
      location.reload();
    })
    .catch( err => {
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    })
  }

  dischargePatient(){
    return this.patientService.dischargePatient(this.updatedUser.id)
    .then(() => {
      alert("Paciente dado de alta satisfactoriamente!");
      location.reload();
    })
    .catch( err => {
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    })
  }

  sendMedicalHistoryEmail() {
    if(!this.medicalHistoryEmails || this.medicalHistoryEmails === "") {
      return alert("Debe ingresar uno o mas emails separados por coma");
    }

    return this.patientService.sendMedicalHistoryEmail(this.user.id, this.medicalHistoryEmails)
    .then(() => alert("Se ha enviado el reporte en formato pdf al email seleccionado."))
    .catch(() => alert("Ocurrió un error al enviar el reporte."))
  }

  togglePatientActive() {
    return this.patientService.setPatientBannedStatus(this.user.id, !this.updatedUser.banned, this.needsAutomaticUnban)
    .then(() => {
      this.updatedUser.banned = !this.updatedUser.banned;
      this.updatedUser.banned ? alert("El paciente fue baneado") : alert("El paciente fue desbaneado");
    })
    .catch(() => {
      this.updatedUser.banned ? alert("Ocurrió un error al desbanear el paciente.") : alert("Ocurrió un error al banear el paciente.")
    })
  }

  toggleNeedsMonitoring() {
    let updatedFields: any = {
      needsMonitoring: !this.newNeedsMonitoring,
      dateToStartNeedsMonitoring: !this.newNeedsMonitoring ? Moment().toISOString() : null
    };

    this.userService.update(this.updatedUser.id, updatedFields)
    .then(() => {
      this.newNeedsMonitoring = !this.newNeedsMonitoring;
      this.newNeedsMonitoring ? alert("El paciente fue agregado a la bolsa de seguimiento.") : alert("El paciente fue quitado de la bolsa de seguimiento.");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/patients/detail/patient-detail.component.ts